import { render, staticRenderFns } from "./ListDissertation_council_scientific_field.vue?vue&type=template&id=ebe5a07c&scoped=true"
import script from "./ListDissertation_council_scientific_field.vue?vue&type=script&lang=js"
export * from "./ListDissertation_council_scientific_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe5a07c",
  null
  
)

export default component.exports